import { Button, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTelecomForLocation } from '../../offices/offices-selectors';
import { capitalize } from 'lodash';
import { createLocation } from '../../offices/offices-actions';
import { getWriteTabsPermissions } from '../../../store/user/user-reducer';
import { formItemMap } from '@med-fe/ui';
import { telecomConfig } from '../configs/telecom-config';

function TelecomDetails({ locId }) {
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const dispatch = useDispatch();
  const data = useSelector((state) => getTelecomForLocation(state, locId));
  const isEditAllowed = useSelector(getWriteTabsPermissions).telecom;

  useEffect(() => {
    form.setFieldsValue({
      ...data,
    });
  }, [locId]);

  const onSubmit = (formData: any) => {
    const payload = {
      ...formData,
      id: locId,
    };
    dispatch(createLocation(payload));
  };

  return (
    <Form
      form={form}
      className='telecom-details-form'
      layout='vertical'
      onFinish={(formData) => {
        onSubmit(formData);
        setIsDisabled(true);
      }}
      onValuesChange={() => setIsDisabled(false)}
    >
      {Object.entries(telecomConfig).map(([key, value]: any) => {
        const params = {
          key,
          label: capitalize(value.label),
          name: key,
          rules: value.rules,
        };
        return <Form.Item {...params}>{formItemMap(value, !isEditAllowed)}</Form.Item>;
      })}

      <Form.Item>
        <Button type='primary' htmlType='submit' className={'btn-form-action'} disabled={!isEditAllowed || isDisabled}>
          SAVE
        </Button>
      </Form.Item>
    </Form>
  );
}

export default TelecomDetails;
